export const USER_PROFILE_RESET_STATE = 'USER_PROFILE_RESET_STATE';
export const USER_PROFILE_CURRENT_ITEM = 'USER_PROFILE_CURRENT_ITEM';

export const USER_PROFILE_REQUEST_LOADING = 'USER_PROFILE_REQUEST_LOADING';
export const USER_PROFILE_REQUEST_SUCCESS = 'USER_PROFILE_REQUEST_SUCCESS';
export const USER_PROFILE_REQUEST_FAILED = 'USER_PROFILE_REQUEST_FAILED';

export const USER_PROFILE_CURRENT_ACTION = 'USER_PROFILE_CURRENT_ACTION';
export const USER_PROFILE_RESET_ACTION = 'USER_PROFILE_RESET_ACTION';